import React from 'react';
import { useTranslation } from 'react-i18next';
import { pickField } from '@/tiktok-platform/utils/tiktokResponse';
import TiktokProductThumb from '@/tiktok-platform/modules/products/components/TiktokProductThumb';
import HoverCopyField from '@/tiktok-platform/modules/products/components/HoverCopyField';
import { normalizeImageUrl } from '@/tiktok-platform/modules/aftersales/returnOrderDisplay';

export function extractGoodsList(row) {
  if (Array.isArray(row?.goodsList) && row.goodsList.length) return row.goodsList;
  if (Array.isArray(row?.itemList) && row.itemList.length) return row.itemList;
  return [];
}

/**
 * 产品信息单元格（样式对齐订单列表：标题悬浮复制 + SKC / 商家SKU）。
 * @param {number|null} maxVisible 列表默认只展示 1 件；传 null 展示全部（详情等场景）
 */
export default function FinanceListGoodsCell({ goods, maxVisible = 1 }) {
  const { t } = useTranslation('workbench');
  const list = Array.isArray(goods) ? goods : [];
  if (!list.length) {
    return <span className="tko-return-product__empty">{t('finance.noGoods')}</span>;
  }
  const limit = maxVisible == null || maxVisible <= 0 ? list.length : maxVisible;
  const visible = list.slice(0, limit);
  return (
    <div className="tko-finance-list-goods">
      <div className="tko-finance-list-goods__grid">
        {visible.map((item, idx) => {
          const title = pickField(item, 'goodsTitle', 'productName', 'spuName', 'title') || '';
          const merchantSku = pickField(item, 'supplierSku', 'sellerSku', 'merchantSku', 'supplier_sku') || '';
          const productId = pickField(item, 'productId', 'product_id', 'skcName', 'skcCode', 'skc', 'platformSkcId') || '';
          const supplierCode = pickField(item, 'supplierCode', 'goodsSn', 'articleNo') || '';
          const img = normalizeImageUrl(pickField(item, 'imageUrl', 'mainImageUrl'));
          const key = `${productId || merchantSku || title || 'g'}-${idx}`;
          if (!title && !img && !productId && !merchantSku && !supplierCode) {
            return (
              <span key={key} className="tko-return-product__empty">{t('finance.noGoods')}</span>
            );
          }
          return (
            <div key={key} className="tko-return-product">
              {img ? (
                <TiktokProductThumb
                  imageUrl={img}
                  className="tko-return-product__img"
                  placeholderClassName="tko-return-product__img tko-return-product__img--empty"
                  alt={title || merchantSku || t('finance.goodsAlt')}
                />
              ) : (
                <div className="tko-return-product__img tko-return-product__img--empty" />
              )}
              <div className="tko-return-product__meta">
                <HoverCopyField
                  value={title}
                  className="tko-return-product__title"
                  popoverCopy
                />
                <HoverCopyField
                  label={t('tiktokCatalog.productId')}
                  value={productId}
                  className="tko-return-product__sku"
                />
                <HoverCopyField
                  label={t('certList.merchantSku')}
                  value={merchantSku}
                  className="tko-return-product__sku"
                />
                {supplierCode ? (
                  <HoverCopyField
                    label={t('tiktokCatalog.supplier')}
                    value={supplierCode}
                    className="tko-return-product__sku"
                  />
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
